import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Fixed locale + UTC so SSR and client hydration match. */
export function formatDateTime(ms: number): string {
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    timeZone: "UTC",
    hour12: true,
  }).format(new Date(ms))
}

export function formatSiteName(name: string): string {
  if (!name) return "";
  if (name.includes(".")) {
    const parts = name.replace(/^www\./, "").split(".");
    if (parts.length > 0) {
      return parts[0].charAt(0).toUpperCase() + parts[0].slice(1);
    }
  }
  return name;
}

